import Swiper from 'swiper/swiper-bundle.min.mjs';

const swiper = new Swiper('.newsSwiper', {
  loop: false,
  spaceBetween: 0,
  breakpoints: {
    0:   { slidesPerView: 1.25 },
   1200: { slidesPerView: 2 }
  },
  // Pfeile im Custom-Container
  navigation: {
    nextEl: '.newsSwiper .swiper-nav-container .swiper-button-next',
    prevEl: '.newsSwiper .swiper-nav-container .swiper-button-prev',
  },
  // Scrollbar im Custom-Container
  scrollbar: {
    el: '.newsSwiper .swiper-nav-container .swiper-scrollbar',
    draggable: true,
  }
});

// Titel und Text maximale Zeilenanzahl zuweisen

// (function () {
//   const TOTAL = 8;

//   function getLineCount(el) {
//     const cs = getComputedStyle(el);
//     const lh = parseFloat(cs.lineHeight);
//     // Falls line-height "normal" ist, Näherung: 1.2 * font-size
//     const lineHeight = isNaN(lh) ? 1.2 * parseFloat(cs.fontSize) : lh;
//     // ClientHeight kann fractional sein; runden auf nächste ganze Zeile
//     const lines = Math.round(el.getBoundingClientRect().height / lineHeight);
//     return Math.max(lines, 0);
//   }

//   function clamp(el, lines) {
//     // number expected – per CSSOM als style-Eigenschaft setzen
//     el.style.webkitLineClamp = String(Math.max(0, Math.floor(lines)));
//   }

//   function redistribute(scope = document) {
//     const cards = scope.querySelectorAll('.news-swiper .card-body');
//     cards.forEach(card => {
//       const h3 = card.querySelector('h3');
//       const p  = card.querySelector('p');
//       if (!h3 || !p) return;

//       // Erst sicherstellen, dass der Titel nicht schon zu hart gekürzt ist
//       // (max TOTAL, damit er nie mehr als TOTAL Zeilen frisst)
//       clamp(h3, TOTAL);

//       // Zwischenmessung nach gesetztem Clamp
//       // (layout thrash minimiert, weil wir nur lesen/schreiben in Blöcken)
//       const titleLines = getLineCount(h3);
//       const remaining  = Math.max(TOTAL - titleLines, 0);

//       clamp(p, remaining);
//     });
//   }

//   // initial: nach Fonts & Layout
//   if (document.readyState === 'complete') {
//     redistribute();
//   } else {
//     window.addEventListener('load', redistribute, { once: true });
//   }

//   // Bei Resize neu verteilen (Schriftumbruch ändert Zeilenzahl)
//   let rafId = null;
//   window.addEventListener('resize', () => {
//     if (rafId) cancelAnimationFrame(rafId);
//     rafId = requestAnimationFrame(() => redistribute());
//   });

//   // Optional: wenn Webfonts asynchron laden
//   if (document.fonts && document.fonts.ready) {
//     document.fonts.ready.then(() => redistribute());
//   }
// })();

